import React from 'react';

import CommonNode from '../../../../components/node/common-node';
import { NodeProvider } from '../../../../context/node-context';
import { getNodeName } from '../../../../utils/getNodeName';
import MoveFileTaskForm from './forms/move-file-task-form';
import { moveFileTaskValidationSchema } from './schema.js';

export default function SftpOperationMoveFileNode({ data, id, type }) {
  const nodeName = getNodeName(data?.name, 'SFTP Operation Move File Task');

  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: nodeName,
        altText: 'SFTP Operation Move File Task',
        defaultLabel: 'SFTP Operation Move File Task',
      }}
    >
      <CommonNode FormComponent={MoveFileTaskForm} schemaResolver={moveFileTaskValidationSchema} />
    </NodeProvider>
  );
}
